<template>
  <div class="all">
    <div id="section1" class="contact-wrap">
      <div class="custom-container">
        <div class="title" data-aos="fade-up" data-aos-duration="800">
          <img src="/static/images/text_form.svg" alt="">
          <h6>請留下您的聯絡方式 我們將會有專人與您聯繫</h6>
        </div>
        <div class="form-wrap" data-aos="fade-in" data-aos-duration="800" data-aos-delay="300">
          <infiniteForm v-bind:Success_modal="Success_modal" v-on:callSuccess="showSuccess"></infiniteForm>
        </div>
      </div>
    </div>
     <submitSuccess v-if="Success_modal" v-bind:closemodal="close_modal" v-on:endSubmit="hideSuccess"></submitSuccess>
  </div>
</template>

<script>
  import navigation from './navigation.vue';
  import infiniteForm from './infiniteForm.vue';
  import submitSuccess from './submitSuccess.vue';

  export default {
    name: 'Contact',
    components: {
      navigation,
      infiniteForm,
      submitSuccess
    },
    data(){
      return{
        Success_modal: false,
        close_modal:true,
      }
    },
    methods:{
          showSuccess(){
                this.Success_modal =  true;
          },
          hideSuccess(){
                this.Success_modal =  false;
          }
    }
  }

</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/common.scss';
  @import 'src/assets/scss/contact/contact.scss';
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue